import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('appointment-form', 'reason_visit-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'reasons_for_visits',
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/reason-visit-req.js